import { format } from 'date-fns';
import { forOwn } from 'lodash';
import getLocalDate from '../getLocalDate';
import config from '../../config';

const forecastTransform = (forecast, forecastWritten, legacyUserSettings, print = false) => {
  const associated = forecast.associated;
  const writtenForecast = 'written' in forecastWritten.data && forecastWritten.data.written ?
    forecastWritten.data.written.map((written) => {
      const offset = associated.timezone.filter(zone =>
        zone.id === written.timezone.id)[0].offset;
      const title = format(getLocalDate(written.timestamp, offset), 'dddd M/D');
      return {
        title,
        ...written,
      };
    }) : null;
  const units = {
    ...associated.units,
    global: associated.units.wave.height,
    wave: associated.units.wave.height,
    wind: associated.units.wind,
  };
  const forecastType = legacyUserSettings.type;
  const addTimeStep = (timeStep, localTimestamp) => ({
    ...timeStep,
    date: {
      local: format(localTimestamp, 'MMMM DD, YYYY HH:MM:SS'),
      timestamp: localTimestamp,
    },
    wave: (() => (
      timeStep.wave ? {
        ...timeStep.wave,
        height: {
          ...timeStep.wave.height,
          average: timeStep.wave.height.mean,
        },
        direction: {
          ...timeStep.wave.direction,
          iconPath: `${config.iconBaseUrl}${timeStep.wave.direction.cardinal}.gif`,
        },
      } : null
    ))(),
    wind: (() => (
      timeStep.wind ? {
        ...timeStep.wind,
        direction: {
          ...timeStep.wind.direction,
          iconPath: `${config.iconBaseUrl}${timeStep.wind.direction.cardinal}.gif`,
        },
      } : null
    ))(),
    weather: timeStep.weather,
  });
  let maxWave = 0;
  let maxWind = 0;
  const days = [];
  let timeSteps = [];
  const forecastData = print ? forecast.data.forecasts.slice(0, 24) : forecast.data.forecasts;
  forecastData.forEach((timeStep, index) => {
    const windPeak = timeStep.wind ? timeStep.wind.speed.peak : 0;
    maxWind = windPeak > maxWind ? windPeak : maxWind;
    const wavePeak = timeStep.wave ? timeStep.wave.height.peak : 0;
    maxWave = wavePeak > maxWave ? wavePeak : maxWave;
    const offset = associated.timezone.filter(zone =>
      zone.id === timeStep.timezone.id)[0].offset;
    const currentStepTimestamp = getLocalDate(timeStep.timestamp, offset);
    const nextStepTimestamp = forecastData.length > index + 1 ? getLocalDate(
      forecastData[index + 1].timestamp,
      offset,
    ) : null;
    const date = format(currentStepTimestamp, 'dddd M/D');
    const nextDate = nextStepTimestamp ? format(nextStepTimestamp, 'dddd M/D') : null;
    if (date === nextDate) {
      timeSteps.push(addTimeStep(timeStep, currentStepTimestamp));
    } else {
      timeSteps.push(addTimeStep(timeStep, currentStepTimestamp));
      days.push({
        date,
        timestamp: currentStepTimestamp,
        monthDay: format(currentStepTimestamp, 'M/D'),
        timeSteps,
      });
      timeSteps = [];
    }
  });
  const urls = {};
  forOwn(associated.urls, (value, key) => {
    urls[`${key}Url`] = value;
  });
  // API currently returns last day with one timestep. We only want full days.
  if (days[days.length - 1].timeSteps.length === 1) days.splice(-1, 1);
  const nearbyRegion = associated.region;
  const dateTime = new Date().getTime();
  const timestamp = Math.floor(dateTime / 1000);
  const currentLocalTime = getLocalDate(timestamp, associated.timezone[0].offset);
  const response = {
    writtenForecast: print && writtenForecast.length > 2 ?
      writtenForecast.slice(0, 6) : writtenForecast,
    charts: {
      days,
      units,
      maxWave,
      maxWind,
      location: associated.location,
    },
    currentLocalTime,
    forecastValidTime: `${format(currentLocalTime, 'dddd, MMMM D')} at ${format(currentLocalTime, 'h a')}`,
    ...urls,
    nearbyRegion,
    forecastType,
    badData: maxWave === 0 && maxWind === 0,
  };
  return response;
};

export default forecastTransform;



// WEBPACK FOOTER //
// ./src/utils/forecasts/forecastTransform.js